import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { REG_HUB_COMMON_CONFIG, RegHubCommonConfig } from '../../reg-hub-common-config';
import { RawVinSights, VinSights } from '../../interfaces/vinsights';

@Injectable({
  providedIn: 'root'
})
export class VinSightsRepositoryService {

  protected _baseLink: string;

  constructor(
      private http: HttpClient,
      @Inject(REG_HUB_COMMON_CONFIG) private config: RegHubCommonConfig) {
      this._baseLink = `${config.rootUrl}/Orders`;
  }

  private generateHeaders = () => {
      return {
          headers: new HttpHeaders({ 'Content-Type': 'application/json' })
      }
  }

  public getVinSights = (orderID: string, parsedResultID: string) => {
      return this.http.get<RawVinSights>(`${this._baseLink}/${orderID}/ParsedResults/${parsedResultID}/VinSights`, this.generateHeaders());
  }
}